import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const IonPageWrapper = styled(IonPage)`
  .img-container {
    width: 100%;
    height: 200px;
    overflow: hidden;

    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    ion-spinner {
      position: absolute;
      right: 0;
    }
  }
`;
